export default "__VITE_ASSET__BX0SEAFp__"